module.exports = __webpack_public_path__ + "img/saas1-sector6.2d8ad812.png";